import styled from 'styled-components';

import media from '@/styles/media.style';
import { BLACK } from '@/styles/variables.style';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: 120px auto;
  max-width: 1060px;
  width: 100%;
  padding: 0 20px;
  text-align: center;
`;

export const ProfileList = styled.div`
  display: flex;
  max-width: 1060px;
  border-top: 1px solid ${BLACK};
  border-bottom: 1px solid ${BLACK};
  flex-direction: column;
`;

export const CompanyOverview = styled.h4`
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 10px;
`;

export const TitleBorder = styled.div`
  margin: 0 auto ${({ bottom }) => bottom};
  width: 40px;
  height: 2px;
  background-color: ${BLACK};
`;

export const ContactLinker = styled.div`
  text-align: left;
  text-decoration: underline;
  font-size: 16px;
  letter-spacing: 1px;
  margin-top: 30px;
  color: ${BLACK};

  > a {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const MarkdownStyle = styled.div`
  p {
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 120px;
    color: ${BLACK};

    > a {
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

export const CompanyProfileList = styled.dl`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  margin: 0;
  padding: 20px 0;

  ${media.tabletP`
    padding: 30px 0px 30px;
  `};

  &:not(:last-child) {
    border-bottom: 1px solid #9b9b9b;
  }
`;

export const CompanyProfileTerm = styled.dt`
  text-align: left;
  font-size: 12px;
  font-weight: bold;
  margin: 0;

  ${media.tabletP`
    width: 30%;
    font-size: 16px;
    font-weight: normal;
  `};
`;

export const CompanyProfileDescription = styled.dd`
  text-align: left;
  font-size: 16px;
  margin: 0;

  ${media.tabletP`
    width: 70%;
    font-size: 14px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/CompanySection.style.js